import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as fromMyZone from '@app/store/my-zone/my-zone';
import { Observable } from 'rxjs';
import { getScenarioEntities, getScenarioIds, getAllScenarios } from './scenarios.selectors';
import { ScenarioInterface } from '@app/core/interfaces';

@Injectable({
    providedIn: 'root'
})
export class ScenariosSelectorService {

    public getScenarioEntities$: Observable<{ [id: string]: ScenarioInterface }> = this.store.pipe(select(getScenarioEntities));
    public getScenarioIds$: Observable<string[]> = this.store.pipe(select(getScenarioIds));
    public getAllScenarios$: Observable<ScenarioInterface[]> = this.store.pipe(select(getAllScenarios));

    constructor(
        private store: Store<fromMyZone.State>
    ) { }
}
